<template>
  <div v-if="!products.length">
    <p class="font-semibold text-sm">Keine Produkte gefunden</p>
    <!-- <pulse-loader
      :loading="true"
      :color="'#4fd1c5'"
      :size="'15px'"
    ></pulse-loader> -->
  </div>
  <div v-else class="flex flex-wrap my-2">
    <div
      class="relative max-w-sm w-full lg:max-w-full lg:flex mt-3 mb-3"
      v-for="product in products"
      :key="product.id"
    >
      <div v-if="product.best_seller" class="absolute">
        <img class="w-16" src="./../../assets/images/best-seller.png" alt="Best Seller">
      </div>
      <form class="pt-6 cursor-pointer float-right" @click="addWishlist(product.id)">
        <i class="cursor-pointer wishlit-icon  absolute far fa-heart text-2xl text-teal-400 hover:text-white"></i>
      </form>
      <router-link :to="{ name: 'product', params: { id: product.id } }">
        <img
          v-if="product.product_image === null"
          class="w-48"
          src="./../../assets/images/no-image.jpg"
          alt="No Image"
        />

        <img v-else class="sm:w-48 sm:justify-center" :src="product.product_image" alt="Product image" />
      </router-link>
      <div
        class="w-full bg-white rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal"
      >
        <div class="mb-8">
          <div class="text-gray-900 text-xl mb-2">
            <router-link
              :to="{ name: 'product', params: { id: product.id } }"
              class="hover:text-teal-400 product-name-450" 
              >{{ product.name }}</router-link
            >
          </div>
          <p class="text-gray-500 text-base">{{ product.name }}</p>

          <div v-if="product.old_price>0">
            <p
              class="text-base line-through font-semibold text-red-500 bg-white  mt-6 text-right">
              {{ product.old_price | formatNumber }}
            </p>
            <p
              class="text-base font-semibold text-teal-400  bg-white text-right">
              {{ product.price | formatNumber }}
            </p>
          </div>
          <div v-else>
            <p
              class="text-base font-semibold text-black bg-white  mt-6 text-right">
              {{ product.price | formatNumber }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";

export default {
  components: {
    // PulseLoader,
  },
  props: {
    products: Array,
  },
  data() {
    return {
      loading: false,
      productId: null
    };
  },
  methods: {
    addWishlist(id) {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");
      
      axios.post(`${process.env.VUE_APP_API}/button-click`, {
        product_id: id,
        button: 'ADD_TO_WISHLIST'
      })
      .catch(error => {
        console.log(error)
      })

      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios
        .post(`${process.env.VUE_APP_API}/wishlist`, {
          product_id: id,
        })
        .then(() => {
          if (!this.error) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Artikel in den Merkliste gelegt",
            });
          }
        })
        .catch((error) => {
          // console.log(error.response.data.error)
          if(error.response.status === 409) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: error.response.data.error,
            });
          }

          if(error.response.status === 401) {
            this.$notify({
              group: "cart",
              title: "Merkliste",
              text: "Nicht authentifiziert",
            });
          }
          this.error = true;
        }); 
    }
  }
};
</script>

<style scoped>
  .wishlit-icon {
    top: 5%;
    left: 12%;
  }

 

  @media(max-width:450px){
     .wishlit-icon {
    top: 2%;
    left: 4%;
  }

  

  }
</style>
